"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AnimationSolid: function() {
        return AnimationSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const AnimationSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M6.00091 9.37443C6.06821 4.73773 9.84752 1 14.5 1C19.1944 1 23 4.80558 23 9.5C23 14.1525 19.2623 17.9318 14.6256 17.9991C14.5838 17.9997 14.5419 18 14.5 18C9.80558 18 6 14.1944 6 9.5C6 9.45808 6.0003 9.41622 6.00091 9.37443Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M2.50514 13.7207C2.50172 13.8135 2.5 13.9067 2.5 14.0001C2.5 18.1423 5.85786 21.5001 10 21.5001C10.094 21.5001 10.1876 21.4984 10.2809 21.4949C9.29587 22.4278 7.96529 23.0008 6.5 23.0008C3.46243 23.0008 1 20.5384 1 17.5008C1 16.036 1.57274 14.7057 2.50514 13.7207Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M14.1601 18.9949C9.18332 18.8199 5.18048 14.8167 5.00594 9.83984C4.19549 10.8117 3.66267 12.0247 3.53151 13.357C3.51065 13.569 3.5 13.7836 3.5 14.0004C3.5 17.5903 6.41015 20.5004 10 20.5004C10.2168 20.5004 10.4315 20.4898 10.6434 20.4689C11.9755 20.3378 13.1883 19.8051 14.1601 18.9949Z",
            fill: "currentColor"
        })
    ]
}), "AnimationSolid");
const _default = AnimationSolid;
